import classnames from "classnames";
import { Collapse, Navbar, NavItem, Nav, Container } from "reactstrap";
import Constants from "utils/Constants";
import GCLogo from "../../assets/img/growthcloud/growthcloud_wordmark.svg";
import GCSymbol from "../../assets/img/growthcloud/growthcloud_symbol.svg";
import { Popover, Whisper } from "rsuite";
import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import useLogout from "api/api-hooks/auth/useLogout";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";
import DropdownMenuDivider from "components/Menus/DropdownMenuDivider";
import gcLogo from "../../assets/img/growthcloud/growthcloud_wordmark_white.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import useUser from "../../api/api-hooks/auth/useUser";
import { userHasSupportalPerms } from "../Options/NavbarAccountOptions";

const modules = Constants.MODULES;

function AdminNavbarNoModule({ theme = "dark", sidenavOpen, toggleSidenav }) {
  const { user } = useUser();
  const { logout } = useLogout();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = window.location.href;

    for (let i = 0; i < modules.length; i++) {
      if (path.indexOf(modules[i].Slug) >= 0) {
        window.root.style.setProperty("--primary", modules[i].Color);

        return;
      }
    }

    window.root.style.setProperty("--primary", Constants.THEME.PRIMARY);
  }, [location]);

  const supportalPerms = userHasSupportalPerms(user);

  return (
    <>
      <Navbar
        className={classnames(
          "v2 navbar-top navbar-expand border-bottom bg-white navbar-light fixed-top"
        )}
      >
        <Container fluid>
          <Collapse navbar isOpen={true}>
            <img
              alt=""
              src={GCLogo}
              style={{ width: 180, marginRight: 50, marginLeft: 10 }}
              className="d-none d-md-block ml-0"
            />
            <img
              alt=""
              src={GCSymbol}
              style={{ height: 24, marginRight: 50, marginLeft: 10 }}
              className="d-block d-md-none ml-0"
            />
            <Nav className="align-items-center" navbar>
              <NavItem className="d-xl-none">
                <div
                  className={classnames(
                    "pr-3 sidenav-toggler",
                    { active: sidenavOpen },
                    { "sidenav-toggler-dark": theme === "dark" }
                  )}
                  onClick={toggleSidenav}
                >
                  <div className="sidenav-toggler-inner">
                    <i className="sidenav-toggler-line" />
                    <i className="sidenav-toggler-line" />
                    <i className="sidenav-toggler-line" />
                  </div>
                </div>
              </NavItem>
              <NavItem className="d-none d-xl-flex">
                <img src={gcLogo} style={{ width: "240px" }} />
              </NavItem>
            </Nav>
            <Nav className="align-items-center ml-auto" navbar>
              <Whisper
                placement="autoVerticalEnd"
                controlId="nav-settings"
                trigger="click"
                speaker={
                  <Popover className="sidebar-popover">
                    <PopoverDropdownMenu>
                      <DropdownOptionWithIcon
                        name="Account Settings"
                        onClick={() => {
                          navigate("/account/profile");
                        }}
                        icon="mdi mdi-account-outline"
                      />
                      <DropdownOptionWithIcon
                        name="Support"
                        onClick={() => {
                          window.open("mailto:support@growthcloud.com");
                        }}
                        icon="mdi mdi-lifebuoy"
                      />
                      {supportalPerms && (
                        <>
                          <DropdownMenuDivider />
                          <DropdownOptionWithIcon
                            name="Open Supportal"
                            onClick={() => {
                              navigate("/supportal");
                              onClose();
                            }}
                            icon="mdi mdi-apps"
                          />
                        </>
                      )}
                      <DropdownMenuDivider />
                      <DropdownOptionWithIcon
                        name="Logout"
                        onClick={logout}
                        icon="mdi mdi-logout-variant"
                      />
                    </PopoverDropdownMenu>
                  </Popover>
                }
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className="nav-link cursor-pointer pl-1 pr-0"
                >
                  <span className="avatar avatar-sm rounded text-capitalize text-center link-hovered bg-white text-secondary">
                    <i
                      className="mdi mdi-account"
                      style={{
                        fontSize: "24px",
                        position: "relative",
                        top: 1,
                      }}
                    />
                  </span>
                </a>
              </Whisper>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbarNoModule;
